// Paths of the public content pages: neighborhood pages, off-campus pages
// and guides. Pure and small, because the router (src/routes/index.jsx)
// and seo/routes.js (in the app shell) both read it. Titles, descriptions
// and JSON-LD live in contentMeta.js, which only the pages and the edge
// middleware load.
//
// To add a page: add its slug here, its data in src/features/guides/content,
// its meta in contentMeta.js and its path in PUBLIC_PAGES
// (server/utils/sitemap.js). contentPages.test.js checks all four agree.

/** Neighborhood pages at /rentals/<slug>. */
export const AREA_SLUGS = [
  'pacific-beach',
  'mission-beach',
  'ocean-beach',
  'north-park',
  'hillcrest',
  'college-area',
  'la-jolla-utc',
  'clairemont',
  'linda-vista',
  'mission-valley',
]

/** Off-campus pages at /off-campus/<slug>. */
export const CAMPUS_SLUGS = ['sdsu', 'ucsd', 'usd']

/** Landlord guides at /guides/<slug>. */
export const LANDLORD_GUIDE_SLUGS = [
  'california-security-deposit-rules',
  'sb-721-balcony-inspections',
  'california-entry-notice',
  'tenant-screening-fees-california',
  'california-late-fees',
]

export const GUIDES_PATH = '/guides'

// The one renter hub guide. Its slug is the only place outside the hub's own
// files (src/features/guides/hub/) where the word in it may be written;
// everything else links to it through this constant.
export const HUB_PATH = '/guides/student-housing-san-diego'

export const areaPath = slug => `/rentals/${slug}`
export const campusPath = slug => `/off-campus/${slug}`
export const guidePath = slug => `${GUIDES_PATH}/${slug}`

/** Every content page path, in sitemap order. */
export const CONTENT_PATHS = [
  GUIDES_PATH,
  HUB_PATH,
  ...LANDLORD_GUIDE_SLUGS.map(guidePath),
  ...AREA_SLUGS.map(areaPath),
  ...CAMPUS_SLUGS.map(campusPath),
]
